export default {"src":"/customer-services/_next/static/media/electrical-product-support.ae27df91.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};